/* ─────────────────────────────────────────────────────────────
   VialidadesModule — Fase 2 (vistas por rol)
   ───────────────────────────────────────────────────────────── */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import VistaLider from "./vialidades/VistaLider";
import VistaJefe from "./vialidades/VistaJefe";
import FormularioMesa from "./vialidades/FormularioMesa";
import ImportExcelTab from "./vialidades/ImportExcelTab";
import { TablaRegistros, Dashboard } from "./vialidades/Registros";
import "./vialidades/vialidades.css";

const ROL_DESC = {
  admin:           "Administrador · acceso total",
  mesa_vial:       "Mesa de Asignación · capturas y reportes",
  visor_vial:      "Visor · solo lectura y exportación",
  supervisor_vial: "Supervisor · estatus + asignaciones",
  lider_vial:      "Líder de Cuadrilla · evidencia y GPS",
  jefe_vial:       "Jefe · programa del día + registros",
  capturista:      "Captura temporal · Plan B",
};

const TABS_POR_ROL = {
  admin:           [["dashboard","Dashboard"], ["captura","Capturar"], ["excel","Importar Excel"], ["registros","Registros"]],
  mesa_vial:       [["captura","Capturar"], ["excel","Importar Excel"], ["registros","Registros"], ["dashboard","Dashboard"]],
  capturista:      [["captura","Capturar"], ["registros","Registros"]],
  visor_vial:      [["registros","Registros"], ["dashboard","Dashboard"]],
  supervisor_vial: [["registros","Registros"], ["dashboard","Dashboard"]],
};

export default function VialidadesModule() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const rol = user?.rol;
  const tabs = TABS_POR_ROL[rol] || [];
  const [tab, setTab] = useState(tabs[0]?.[0] || "");

  // Vistas dedicadas (sin tabs internos del shell)
  const VISTA_DEDICADA = {
    lider_vial: <VistaLider user={user}/>,
    jefe_vial:  <VistaJefe user={user}/>,
  };

  return (
    <div className="via-shell" data-testid="page-vialidades">
      <header className="via-top">
        <button className="back" onClick={() => navigate("/hub")} aria-label="Atrás" data-testid="btn-back-hub">
          <i className="fa-solid fa-arrow-left"/>
        </button>
        <div className="icon-circ"><i className="fa-solid fa-road"/></div>
        <div>
          <h1>Vialidades</h1>
          <small>{user?.nombre} · {ROL_DESC[rol] || rol}</small>
        </div>
        <div className="spacer"/>
        <button className="logout" onClick={logout} data-testid="btn-logout-vialidades">
          <i className="fa-solid fa-right-from-bracket"/> Salir
        </button>
      </header>

      {tabs.length > 0 && (
        <div className="via-tabs" data-testid="vial-tabs">
          {tabs.map(([k, lbl]) => (
            <button key={k} className={`via-tab ${tab === k ? "active" : ""}`} onClick={() => setTab(k)} data-testid={`vial-tab-${k}`}>
              {lbl}
            </button>
          ))}
        </div>
      )}

      <main className="via-content">
        {VISTA_DEDICADA[rol] ? (
          VISTA_DEDICADA[rol]
        ) : (
          <>
            {tab === "captura" && <FormularioMesa user={user}/>}
            {tab === "excel" && <ImportExcelTab/>}
            {tab === "registros" && <TablaRegistros user={user} modo={rol === "admin" ? "admin" : (rol === "supervisor_vial" ? "supervisor" : "lectura")}/>}
            {tab === "dashboard" && <Dashboard/>}
          </>
        )}
      </main>
    </div>
  );
}
